export default __webpack_public_path__ + "static/media/plan-your-learning-kelly-sikkema-min.750f5a0a.jpg";